import * as React from "react";
import classnames from "classnames";
/* empty css                    */
const FlyoutMenuItem = ({
  link,
  action,
  children,
  className,
  tealiumAttributes,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("li", { className: classnames("flyout-menu-item", className), ...rest }, !action && link && /* @__PURE__ */ React.createElement("a", { href: link, className: "flyout-menu-item__link", ...tealiumAttributes }, children), action && /* @__PURE__ */ React.createElement("button", { onClick: action, className: "flyout-menu-item__link" }, children));
};
export {
  FlyoutMenuItem as default
};
//# sourceMappingURL=FlyoutMenuItem.js.map
